import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import Loading from "../Loading";
import { ButtonPrimary } from "../Button";
import { Input, Select, Textarea } from "../../ui";
import {
  objectDiff,
  processFormValues,
  renderFormInput,
} from "../../modules/formTools";
import { Failed, Succeeded, Toggle } from "../Form";
import isArray from "lodash/isArray";
import { email, required } from "../../modules/validation";
import {
  checkAgencyHasFeature,
  isRolePlatformAdmin,
  token,
} from "../../modules/auth";
import { agencyCompanyDomains } from "../../services/companyService/agencyCompanyDomains";
import { AGENCY_PERMISSIONS } from "../../constants";
import { editCompany } from "../../redux/actions";
import { isDirty } from "redux-form/immutable";
const v = {
  required: required(),
  email,
};

const mapStateToProps = (state, props) => {
  let initialValues = {};
  let legalText =
    "<p>The contract for this event will be between :companyVar and the :venueVar. Please send the contract directly to the client. All deposits and accounts will be settled directly between the venue and the client. :agencyVar has acted as an agency in respect of this booking and will claim commission as per the below breakdown. :agencyVar provides a venue finding service both in the UK and Internationally. </p><p>Prices quoted include tax at the rate specified, but are subject to change</p>";
  let legalTTextInvoice =
    "<p>Payment is due within 14 days from the date of the invoice.<br/>Please quote invoice number on all payment advice.</p>";

  if (Object.entries(props.company).length > 0) {
    initialValues = {
      ...props.company,
      ...props.company.address,
      legal_text: props.company?.legal_text || legalText,
      legal_text_invoice:
        props.company?.legal_text_invoice || legalTTextInvoice,
    };
  }

  if (props.agencyCode) {
    initialValues.agency_code = props.agencyCode;
  }

  if (props.company.note) {
    initialValues.company_note = props.company.note.content;
  }
  return {
    initialValues,
    token: token(state),
    isRolePlatformAdmin: isRolePlatformAdmin(state),
    companyAgencyFeatures: state.agencyFeatures?.agencyFeatures,
    isDirty: isDirty("companyTargets")(state),
  };
};
const mapDispatchToProps = {
  editCompany,
};
class CompanyTargetsForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
      companyDomains: null,
      domainError: [],
      isDummyCompany: false,
    };
  }

  componentDidMount() {}

  wrapperSubmit = async formValues => {
    if (this.props.isDirty) {
      return this.props
        .editCompany(this.props.company.id, formValues, this.props.token)
        .then(response => {
          this.setState({
            success: true,
            error: false,
          });
        })
        .catch(error => {
          this.setState({
            error: true,
            errorMessage:
              error?.response?.data?.status === "error"
                ? error.response.data.message
                : "",
          });
        });
    }
  };

  onSubmit = formValues => {
    this.setState({
      errorMessage: "",
    });
    const formData = new FormData();
    if (this.props.dirty && Object.keys(this.props.initialValues).length > 0) {
      formData.append("_method", "PATCH");
      const data = objectDiff(this.props.initialValues, formValues);
      Object.entries(data).forEach(([key, value]) => {
        if (value && !isArray(value)) {
          formData.append(key, value);
        } else {
          if (value && value.length > 0) {
            formData.append(key, JSON.stringify(value));
          }
          if (key == "address2" || key == "address3") {
            formData.append(key, value);
          }
        }
      });
      return this.wrapperSubmit(formData, this.props.token).catch(errors => {
        if (errors?.response?.data?.status === "error") {
          this.setState({
            errorMessage: errors.response.data.message,
          });
        }
        if (errors?.errors?.name) {
          this.setState({
            errorMessage: errors?.errors?.name,
          });
        }
      });
    } else {
      Object.entries(formValues).forEach(
        ([key, value]) => value && formData.append(key, value)
      );
      try {
        return this.wrapperSubmit(formData, this.props.token).catch(errors => {
          if (errors?.response?.data?.status === "error") {
            this.setState({
              errorMessage: errors.response.data.message,
            });
          }
          if (errors?.errors?.name) {
            this.setState({
              errorMessage: errors?.errors?.name,
            });
          }
        });
      } catch (error) {
        return this.wrapperSubmit(formData, this.props.token);
      }
    }
    return processFormValues(this.props, formValues, this.props.initialValues);
  };

  render() {
    const {
      company,
      countries,
      industries,
      bookingDesks,
      agency,
      selectedAgencies,
      isSuperAgent,
      fullWidth = false,
      isRolePlatformAdmin,
      isRoleEdgeAdmin,
      companyAgencyFeatures,
    } = this.props;
    const options = [];
    return (
      <div>
        <div className="overflow-hidden sm:rounded-lg">
          <form
            className="border-none"
            onSubmit={this.props.handleSubmit(this.onSubmit)}
          >
            <div className={"row"}>
              <div className={`col col-w-full mb-6 `}>
                <div className={"p-2"}>
                  <h3>
                    <strong>Targets</strong>
                  </h3>
                  <Field
                    name="total_cost_saving_target"
                    label="Total Cost Saving Target (%)"
                    component={Input}
                    wrapperClassName={"w-full mb-2"}
                    validate={v.default_event_commission_percentage}
                    size="lg"
                  />
                  <Field
                    name="total_commission_target"
                    label="Total Commission Target (%)"
                    component={Input}
                    validate={v.default_event_commission_percentage}
                    wrapperClassName={"w-full mb-2"}
                    size="lg"
                  />
                  <Field
                    name="total_conversion_target"
                    label="Total Conversion Target (%)"
                    wrapperClassName={"w-full mb-2"}
                    component={Input}
                    validate={v.default_event_commission_percentage}
                    size="lg"
                  />
                </div>
                <ButtonPrimary type="submit" classes={"py-2 ml-2"}>
                  {this.props.submitting ? <Loading inline /> : "Save"}
                </ButtonPrimary>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

//const validate = {
//  name: required("Please enter a Company Name"),
//  code: required("Please enter a Company Code"),
//  address1: required("Please enter Address Line 1"),
//  address2: required("Please enter Address Line 2"),
//  city: required("Please enter City"),
//  county: required("Please enter County"),
//  postcode: required("Please enter Postcode"),
//  country_id: required("Please choose a country")
//};

CompanyTargetsForm = reduxForm({
  form: "companyTargets",
  enableReinitialize: true,
  destroyOnUnmount: false,
})(CompanyTargetsForm);

export default connect(mapStateToProps, mapDispatchToProps)(CompanyTargetsForm);
